export default "__VITE_ASSET__C0IDJk3z__"